
          import "index_1g6aisz.linaria.css";
          import React from "react";
import { css } from "@linaria/core";
import SearchIcon from "./search-16px.svg";
import CloseIcon from "./close-16px.svg";
import ErrorIcon from "./error-filled-16px.svg";
import CheckMarkIcon from "./check-filled-16px.svg";
import HeartChecked from "./checked.svg";
import HeartUnchecked from "./unchecked.svg";
const checked = "cop3gkk";
const unchecked = "ujo0soa";

const HeartCheckedIcon = () => /* @__PURE__ */React.createElement(HeartChecked, {
  className: checked,
  "data-testid": "checked"
});

const HeartUncheckedIcon = () => /* @__PURE__ */React.createElement(HeartUnchecked, {
  className: unchecked,
  "data-testid": "unchecked"
});

export { SearchIcon, CloseIcon, ErrorIcon, CheckMarkIcon, HeartCheckedIcon, HeartUncheckedIcon };
          